<template>
    <div>
        <v-simple-table v-if="getSpecificPeriodsDiffs(diff.diffs, 'add&update').length > 0"
                        v-for="openingDiff in getSpecificPeriodsDiffs(diff.diffs, 'add&update')">
            <tr>
                <td v-if="openingDiff.old === null" width="40%"
                    :style="'background-color:' + addColors.light">
                </td>
                <td v-else width="40%" :style="'background-color:' + getPeriodColors(openingDiff).light">
                    <opening-period-diff-card :opening-diff="openingDiff"
                                              :data="openingDiff.old"></opening-period-diff-card>
                </td>

                <td width="20%" :style="'background-color:' + getPeriodColors(openingDiff).light">
                    <icons-between-columns :diff="openingDiff"></icons-between-columns>
                </td>

                <td v-if="openingDiff.new === null" width="40%">
                </td>
                <td v-else width="40%" :style="'background-color:' + getPeriodColors(openingDiff).light">
                    <opening-period-diff-card :opening-diff="openingDiff"
                                              :data="openingDiff.new"></opening-period-diff-card>
                </td>
            </tr>
        </v-simple-table>

        <div v-if="getSpecificPeriodsDiffs(diff.diffs, 'delete').length > 0">
            <v-expansion-panels>
                <v-expansion-panel :style="'background-color:' + deleteColors.light">
                    <v-expansion-panel-header :style="'background-color:' + deleteColors.light">
                                <span class="text-danger">
                            <v-icon color="red">delete_outline</v-icon>
                            Les périodes d'ouverture suivantes ont été supprimées :
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="d-flex">
                            <div v-for="openingDiff in getSpecificPeriodsDiffs(diff.diffs, 'delete')">
                                <opening-period-diff-card :opening-diff="openingDiff"
                                                          :data="openingDiff.old"
                                                          class="mx-2"
                                ></opening-period-diff-card>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>

import OpeningPeriodDiffCard from "./cardDiffsComponents/OpeningPeriodDiffCard.vue"
import IconsBetweenColumns from "./cardDiffsComponents/IconsBetweenColumns.vue"
import { mapState } from "vuex"

export default {
    name: "OpeningPeriodFieldDiffs",
    props: ["diff"],
    components: {
        OpeningPeriodDiffCard,
        IconsBetweenColumns,
    },
    methods: {
        getSpecificPeriodsDiffs(diffs, type) {
            if (type === "add&update") {
                return diffs.filter(diff => diff.type === "ADDED" || diff.type === "UPDATED")
            } else if (type === "delete") {
                return diffs.filter(diff => diff.type === "DELETED")
            }
        },
        getPeriodColors(openingDiff) {
            if (openingDiff.old === null) {
                return this.addColors
            } else if (openingDiff.new !== null) {
                return this.updateColors
            } else {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>